import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';

@Injectable()
export class PersonCurrentMedicationStore extends ComponentStoreV2Factory {

    folderMedications = computed(() => this.data.getFolderMedications()?.items ?? []);

    constructor() {
        super();
    }
}
